var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVeryImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.84375C11.293 1.84375 6.50977 4.62891 3.90625 9.10938C1.30273 13.6504 1.30273 19.1602 3.90625 23.6406C6.50977 28.1816 11.293 30.9062 16.5 30.9062C21.6465 30.9062 26.4297 28.1816 29.0332 23.6406C31.6367 19.1602 31.6367 13.6504 29.0332 9.10938C26.4297 4.62891 21.6465 1.84375 16.5 1.84375ZM16.5 31.875C10.9297 31.875 5.84375 28.9688 3.05859 24.125C0.273438 19.3418 0.273438 13.4688 3.05859 8.625C5.84375 3.8418 10.9297 0.875 16.5 0.875C22.0098 0.875 27.0957 3.8418 29.8809 8.625C32.666 13.4688 32.666 19.3418 29.8809 24.125C27.0957 28.9688 22.0098 31.875 16.5 31.875ZM16.5 8.625C16.7422 8.625 16.9844 8.86719 16.9844 9.10938V18.7969C16.9844 19.0996 16.7422 19.2812 16.5 19.2812C16.1973 19.2812 16.0156 19.0996 16.0156 18.7969V9.10938C16.0156 8.86719 16.1973 8.625 16.5 8.625ZM17.4688 22.1875C17.4688 22.7324 16.9844 23.1562 16.5 23.1562C15.9551 23.1562 15.5312 22.7324 15.5312 22.1875C15.5312 21.7031 15.9551 21.2188 16.5 21.2188C16.9844 21.2188 17.4688 21.7031 17.4688 22.1875Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeryImportant);
export default __webpack_public_path__ + "static/media/icon_very_important.e36ced0b1e616b04180de93dadcdfcfd.svg";
export { ForwardRef as ReactComponent };